import { SplitHeading } from '@/design-system/v2/components/split-heading'
import { cn } from '@/utils/styles/cn'

export const getLandingPageTitleClass = () =>
    'ds-heading ds-text-3xl md:ds-text-4xl text-gray-900 max-w-[650px] leading-[1.15] md:leading-[1.2] text-center tracking-[-0.8px]'

export const getLandingPageSubtitleClass = () =>
    'ds-body ds-text-base text-[#171717CC] max-w-[500px] leading-relaxed text-center pt-4 mb-4'

type ILandingPageSectionHeaderProps = {
    title: string
    titleFaded?: string
    subtitle?: string
    className?: string
    titleClassName?: string
    subtitleClassName?: string
    align?: 'center' | 'left'
    variant?: 'light' | 'dark'
    as?: 'h1' | 'h2' | 'h3'
}

export const LandingPageSectionHeader = ({
    title,
    titleFaded,
    subtitle,
    className,
    titleClassName,
    subtitleClassName,
    align = 'center',
    variant = 'light',
    as = 'h2',
}: ILandingPageSectionHeaderProps) => {
    const isLeft = align === 'left'
    const isDark = variant === 'dark'
    const HeadingTag = as

    const headingText = titleFaded ? `${title}\n${titleFaded}` : title

    return (
        <div className={cn('flex w-full flex-col gap-[18px] mb-10', isLeft ? 'items-start' : 'items-center', className)}>
            <HeadingTag
                className={cn(
                    'ds-h1-section ds-heading',
                    isDark ? 'text-white' : 'text-[#0A0A0A]',
                    isLeft ? 'text-left' : 'text-center',
                    titleClassName
                )}
            >
                <SplitHeading
                    text={headingText}
                    animate={false}
                    secondLineClassName={isDark ? 'text-white/40' : 'text-[#0A0A0A59]'}
                />
            </HeadingTag>
            {subtitle && (
                <p
                    className={cn(
                        'ds-subtitle ds-body max-w-[581px] text-balance',
                        isDark ? 'text-[#8f8c8b]' : 'text-[#8f8c8b]',
                        isLeft ? 'text-left' : 'text-center',
                        subtitleClassName
                    )}
                >
                    {subtitle}
                </p>
            )}
        </div>
    )
}
